import type { GpuCanvasMirror } from "../LivePreview/Strategy/GpuCanvasMirror";

class SceneManager {
  private Stream?: MediaStream;

  private Preview: GpuCanvasMirror | null | undefined;
  private readonly previewListeners = new Set<() => void>();

  getPreview = () => this.Preview;

  subscribePreview = (listener: () => void) => {
    this.previewListeners.add(listener);
    return () => { this.previewListeners.delete(listener); };
  };

  setPreview(preview: GpuCanvasMirror | null | undefined) {
    if (this.Preview === preview) return;
    this.Preview = preview;
    this.previewListeners.forEach(listener => listener());
  }

  clearPreview(preview: GpuCanvasMirror | null) {
    if (this.Preview === preview) this.setPreview(undefined);
  }

  constructor() {}

  getStream() {
    return this.Stream;
  }

  setStream(stream: MediaStream) {
    this.Stream = stream;
  }

  destroy() {
    this.setPreview(undefined);
    if (this.Stream) {
      this.Stream.getTracks().forEach(track => track.stop());
      this.Stream = undefined;
    }
  }
}

export default new SceneManager();
